<template>
  <ClientOnly>
    <header id="page-topbar">
      <div class="navbar-header">
        <div class="d-flex">
          <HederLogo />

          <button
            type="button"
            class="btn btn-sm px-3 font-size-16 header-item vertical-menu-btn"
            id="vertical-menu-btn"
            @click="toggleMenu"
            aria-label="Otvori meni"
          >
            <i class="esei icon-bars"></i>
          </button>
        </div>

        <div class="d-flex">
          <Profile @logoutUser="logoutUser" />
        </div>
      </div>
    </header>
  </ClientOnly>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRuntimeConfig } from '#app'
import { useRouter } from 'vue-router'
import { LanguagesWithFlag } from '~/components/layouts/utils/topBar.js'

import HederLogo from '~/components/layouts/common/HeaderLogo.vue'
import Profile from '~/components/layouts/common/ProfileCms.vue'

// ✅ OVDE JE FALILO
const emit = defineEmits(['toggleMenu'])

const config = useRuntimeConfig()
const router = useRouter()

const languages = LanguagesWithFlag
const current_language = ref('en')
const text = ref(null)
const flag = ref(null)
const value = ref(null)

onMounted(() => {
  const defaultLang = languages.find((x) => x.language === 'en')
  if (defaultLang) {
    value.value = defaultLang
    text.value = defaultLang.title
    flag.value = defaultLang.flag
  }
})

const toggleMenu = () => {


  if (!process.client) return

  if (isDesktop()) {
   
    const collapsed = isCollapsedNow()
   

    setCollapsed(!collapsed)
  } else {
    

    document.body.classList.toggle('sidebar-enable')
  }
}
const isDesktop = () => window.innerWidth >= 992

// Jedina istina: trenutno collapsed ili ne (čitamo sa body-a)
const isCollapsedNow = () => {
  return (
    document.body.classList.contains('vertical-collpsed') ||
    document.body.getAttribute('data-sidebar-size') === 'small'
  )
}

const setCollapsed = (collapsed) => {
  // Ne diramo boju (data-sidebar) uopšte.
  // Samo size/collapse klase + atributi.
  if (collapsed) {
  

    document.body.classList.add('vertical-collpsed')
    document.body.setAttribute('data-sidebar-size', 'small')
    document.body.setAttribute('data-keep-enlarged', 'true')
  } else {
    
    
    document.body.classList.remove('vertical-collpsed')
    document.body.removeAttribute('data-sidebar-size')
    document.body.removeAttribute('data-keep-enlarged')
  }
}

const normalizeForMode = () => {
  if (!process.client) return

  if (isDesktop()) {
    // desktop: nikad overlay
    document.body.classList.remove('sidebar-enable')
  } else {
    // mobile: nema collapse režima
    document.body.classList.remove('vertical-collpsed')
    document.body.removeAttribute('data-sidebar-size')
    document.body.removeAttribute('data-keep-enlarged')
  }
}
const setLanguage = (data) => {
  const { language, country, flag: flagIcon } = data
  current_language.value = language
  text.value = country
  flag.value = flagIcon
}

const initFullScreen = () => {
  document.body.classList.toggle('fullscreen-enable')

  const docEl = document.documentElement
  if (
    !document.fullscreenElement &&
    !document.mozFullScreenElement &&
    !document.webkitFullscreenElement
  ) {
    if (docEl.requestFullscreen) docEl.requestFullscreen()
    else if (docEl.mozRequestFullScreen) docEl.mozRequestFullScreen()
    else if (docEl.webkitRequestFullscreen)
      docEl.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT)
  } else {
    if (document.cancelFullScreen) document.cancelFullScreen()
    else if (document.mozCancelFullScreen) document.mozCancelFullScreen()
    else if (document.webkitCancelFullScreen) document.webkitCancelFullScreen()
  }
}

</script>
